<template>
  <div v-if="residentialStatus != null" class="">
    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <div class="label-standard">What is your residential status?</div>

        <div class="form-line">
          <select 
            class="select-standard"
            :value="residentialStatus.residentialStatus"
            v-on:change="updateValue({
              objectType: 'residentialStatus',
              key       : 'residentialStatus', 
              value     : $event.target.value
            })">
            <option value="-1" disabled="">Select an option...</option>
            <option value="0">Renting</option>
            <option value="1">Own Home</option>
            <option value="2">Own Home With Mortgage</option>
            <option value="3">Boarding</option>
            <option value="4">With Parents</option>
            <option value="5">Other</option>
          </select>
        </div>
      </div>

      <div :class="{ 
        'w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0' : true, 
        'hidden' : !(residentialStatus.residentialStatus != null && residentialStatus.residentialStatus != -1 && residentialStatus.residentialStatus != 1 && residentialStatus.residentialStatus != 2) }">
        <InputDollarValue 
          label="Payment"
          propertyKey="currentRent"
          objectType="residentialStatus"
          :value="residentialStatus.currentRent"
          :updateValue="updateValue"
          :focusWhen="residentialStatus.residentialStatus == 0 || residentialStatus.residentialStatus == 3 || residentialStatus.residentialStatus == 4 || residentialStatus.residentialStatus == 5"/>
      </div>

      <div :class="{ 
        'w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0' : true, 
        'hidden' : !(residentialStatus.residentialStatus != null && residentialStatus.residentialStatus != -1 && residentialStatus.residentialStatus != 1 && residentialStatus.residentialStatus != 2) }">
        <div class="label-standard">Payment frequency</div>

        <div class="radio-line flex items-center">
          <InputRadio 
            name="inputPeriod"
            id="inputPeriodWeekly"
            propertyKey="period"
            value="0"
            :checked="residentialStatus.period == 0"
            :updateValue="updateValue" />
          
          <label class="text-base ml-2 mr-8" for="inputPeriodWeekly">Weekly</label>

          <InputRadio 
            name="inputPeriod"
            id="inputPeriodMonthly"
            propertyKey="period"
            value="1"
            :checked="residentialStatus.period == 1"
            :updateValue="updateValue" />

          <label class="text-base ml-2" for="inputPeriodMonthly">Monthly</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios              from 'axios'
  import moment             from 'moment'
  import InputText          from '@/shared/components/form/InputText'
  import InputRadio         from '@/shared/components/form/InputRadio'
  import InputDollarValue   from '@/shared/components/form/InputDollarValue'
  import StateSelector      from '@/shared/components/form/StateSelector'
  import CountrySelector    from '@/shared/components/form/CountrySelector'
  import { EventBus }       from '@/shared/event-bus'
  
  export default {

    components: {
      InputText,
      InputRadio,
      InputDollarValue,
      StateSelector,
      CountrySelector,
    },

    data() {
      return {
        residentialStatus: null,
      }
    },

    created() {
      this.getData()
    },

    methods : {

      getData() {
        this.apiGet({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId          
        }, 'liability/residential-status', (residentialStatus) => {
          this.hideLoader()
          this.residentialStatus = residentialStatus
          if(this.residentialStatus.residentialStatus == null) {
            this.residentialStatus.residentialStatus = -1
          }
        })
      },

      // a method that will receive the value and update
      updateValue(params) {
        if(this.residentialStatus[params.key] != params.value) {
          this.residentialStatus[params.key] = params.value
          EventBus.$emit('set-autosave', true)
          this.apiPost({
            clientId   : this.$route.params.clientId,
            liabilityId: params.objectId,
            key        : params.key,
            value      : params.value            
          }, 'liability/edit-residential-status', () => {
            EventBus.$emit('set-autosave', false)
          })
        }
      }
    }
  }
</script>